export default __webpack_public_path__ + "static/logo-c3587c73038131924c7d665d01c11094.png";